import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { toast } from "react-toastify";
import { Dialog, Classes, Button, Collapse, Tag } from "@blueprintjs/core";
import { getTag } from "../utils/getStatus";
import { formatCnpj } from "../../utils";

interface ContestacoesProps { }

interface ContestacoesState {
  date1: string;
  date2: string;
  date: any;
}

@observer
export default class Contestacoes extends React.Component<ContestacoesProps, ContestacoesState> {

  obs = observable({
    tarefas_page: 1 as number,
    detalhes_contestacao: false as boolean,
    showErrors: false as boolean,
  })
  
  constructor(props: any) {
    super(props);
  }

  handleBuscaTarefas = async (page: number) => {
    ResultadoStore.handleConsultaTodas(page, 15);
  };

  handleCloseDetalhes() {
    this.obs.showErrors = false;
    this.obs.detalhes_contestacao = false;
  }

  render() {
    function statusFormatter(cell, row) {

      return getTag(row.status);

    }

    function dateFormatter(cell, row) {
      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
    }

    function stringFormatter(cell, row) {
      return cell.toUpperCase();
    }

    const handleViewDetalhes = async (row) => {
      await ResultadoStore.summary_contestacao(
        row.contestacao_id,
        row.tipo,
        row.modelo
      );

      if (!ResultadoStore.obs.isValida) {
        let contestacaoId = ResultadoStore.obs.contestacao_summary.import._id;
        await ResultadoStore.busca_erros_contestacao(contestacaoId);
        this.obs.detalhes_contestacao = true;
      } else {
        toast.warning("Sem dados para mostrar.", {});
      }
    };

    function buttonFormatterDetalhes(cell, row) {
      return (
        <>
          <MDBBtn
            disabled={!row._id}
            color="default"
            rounded
            size="sm"
            onClick={(e) => handleViewDetalhes(row)}
          >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    let errosTextValidate = ResultadoStore.obs.erros_contestacao.length;

    let errosText = ResultadoStore.obs.erros_contestacao?.map((obj) => {
      return <p>({obj.mensagem})</p>;
    });

    function cnpjFormatter(cell, row) {

      if (!cell) return ""

      return formatCnpj(cell)

    }

    return (
      <>
        <Dialog
          isOpen={this.obs.detalhes_contestacao}
          title="Detalhes da Contestação"
          onClose={() => this.handleCloseDetalhes()}
          className={this.obs.showErrors ? "import_error" : "import_pass"}
        >
          <div className={Classes.DIALOG_BODY}>
            <MDBRow>
              <MDBCol md="5">
                <div>
                  <h3 className="arquivosProcessados">
                    <span className="roundCount">
                      {ResultadoStore.obs.contestacao_summary.import.total}
                    </span>{" "}
                    Total de Arquivos Processados
                  </h3>
                  <h3 className="arquivosProcessados">
                    <span className="roundCount">
                      {ResultadoStore.obs.contestacao_summary.import.contestados}
                    </span>{" "}
                    Arquivo(s) Contestado(s)
                  </h3>
                  <h3 className="arquivosProcessados">
                    <span
                      className={
                        ResultadoStore.obs.contestacao_summary.import.erros >= 1
                          ? "roundCount roundCountError"
                          : "roundCount roundNotError"
                      }
                    >
                      {" "}
                      {ResultadoStore.obs.contestacao_summary.import.erros}
                    </span>{" "}
                    Arquivo(s) com Erro(s)
                  </h3>
                  {errosTextValidate ? (
                    <Button
                      onClick={() => (this.obs.showErrors = !this.obs.showErrors)}
                      className="erroCalculoBtn hvr-buzz"
                      style={{ marginTop: 25 }}
                    >
                      {this.obs.showErrors ? "Ocultar" : "Mostrar"} erros
                    </Button>
                  ) : (
                    <></>
                  )}
                </div>
              </MDBCol>

              <MDBCol md="7">
                <div style={{ marginTop: -65 }}>
                  <Collapse isOpen={this.obs.showErrors}>
                    <div className="flash-error">
                      {errosTextValidate && (
                        <>
                          <div style={{ textAlign: "center", marginTop: 0 }}>
                            <img
                              src="images/erro_calculo.svg"
                              width={50}
                              style={{ display: "inline-block" }}
                            />
                            <h3>Erros foram encontrados</h3>
                          </div>
                          <div style={{ overflow: "auto", height: 350 }}>
                            {errosText}
                          </div>
                        </>
                      )}
                    </div>
                  </Collapse>
                  <Collapse isOpen={!errosTextValidate}>
                    <div className="flash-error">
                      <div style={{ textAlign: "center", marginTop: 50 }}>
                        <img
                          src="images/pass_calculo.png"
                          width={50}
                          style={{ display: "inline-block" }}
                        />
                        <h3 style={{ color: "#46eb7d" }}>
                          Nenhum erro encontrado.
                        </h3>
                      </div>
                    </div>
                  </Collapse>
                </div>
              </MDBCol>
            </MDBRow>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button
                text="Fechar"
                onClick={() => this.handleCloseDetalhes()}
              />
            </div>
          </div>
        </Dialog>

        <div data-tut="table">
          <BootstrapTable
            className="TableDefault"
            ref="table"
            data={ResultadoStore.obs.tasks_contestacao}
            data-tut="table"
          >
            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">
              {" "}
              #{" "}
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="15%">Empresa</TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={dateFormatter}
              dataField="inserted_at"
              width="20%"
            >
              Data
            </TableHeaderColumn>
            <TableHeaderColumn dataField="motivo" width="40%">
              Motivo
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={stringFormatter}
              dataField="tipo"
              width="10%"
            >
              Tipo
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={stringFormatter}
              dataField="modelo"
              width="10%"
            >
              Modelo
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={statusFormatter} width="30%">
              Status
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="10%">
              Detalhes
            </TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.tarefas_page}
            totalCount={ResultadoStore.obs.length_tasks_contestacao}
            pageSize={15}
            onPageChange={(page) =>
              this.handleBuscaTarefas((this.obs.tarefas_page = page))
            }
          />
        </div>
      </>
    );
  }
}
